import { render, staticRenderFns } from "./ReportSlowCustomers.vue?vue&type=template&id=77be3a5a"
import script from "./ReportSlowCustomers.vue?vue&type=script&lang=js"
export * from "./ReportSlowCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77be3a5a')) {
      api.createRecord('77be3a5a', component.options)
    } else {
      api.reload('77be3a5a', component.options)
    }
    module.hot.accept("./ReportSlowCustomers.vue?vue&type=template&id=77be3a5a", function () {
      api.rerender('77be3a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ReportSlowCustomers.vue"
export default component.exports